import FeedbackDialog from './FeedbackDialog';
import BillingFeedbackDialog from './FeedbackDialog.billing';
import { isBilling } from '@constants/project';

const FeedbackDialogComponent = isBilling ? BillingFeedbackDialog : FeedbackDialog;

export default FeedbackDialogComponent;
